/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { addContent, invalidateSelectedContent, updateNoLiveContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage } from '@insticator/insticator-ui'; // iui-state
// component
import NewContentCTA from 'material/ctas/newcontent/newcontent';



/* ========== ~~~~~~~~~~ CTA : NEW CONTENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    selectedContent: embedsState.embedManagementState.contentStatus.contents[embedsState.embedManagementState.contentStatus.selectedContent]
});

// map actions
const mapDispatchToProps = dispatch => ({
    addContent: (contentType, placement) => dispatch(addContent(contentType, placement)),
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendMessage: message => dispatch(sendMessage(message)),
    updateNoLiveContent: bool => dispatch(updateNoLiveContent(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(NewContentCTA);
